"use client";

import { IconBulb } from "@tabler/icons-react";
import { useLanguage } from "../../../context/LanguageContext";

type Props = {};
const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const RequestModal = (props: Props) => {
  const { t } = useLanguage();

  return (
    <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <SectionHeader icon={IconBulb} title={t("integration tips")} />
      <div className="space-y-4">
        <h2 className="text-[#212121] font-medium text-base">
          🔧 {t("what this integration does:")}
        </h2>
        <ul className="list-disc pl-6">
          <li>{t("automatically fetches new orders from your shopify store.")}</li>
          <li>{t("syncs shipping information and order status in real time.")}</li>
          <li>{t("generates shipping labels directly from your dashboard.")}</li>
          <li>{t("reduces manual work and speeds up fulfillment.")}</li>
        </ul>
        <h2 className="text-[#212121] font-medium text-base">
          🔐 {t("permissions required:")}
        </h2>
        <ul className="list-disc pl-6">
          <li>{t("access to order details.")}</li>
          <li>{t("access to customer shipping addresses.")}</li>
          <li>{t("permission to write back order tracking info.")}</li>
        </ul>
        <h2 className="text-[#212121] font-medium text-base">
          📌 {t("what you’ll need to provide:")}
        </h2>
        <ul className="list-disc pl-6">
          <li>{t("your shopify store url (e.g., myshop.myshopify.com).")}</li>
          <li>{t("access credentials or install the integration app.")}</li>
          <li>{t("admin access to your store.")}</li>
        </ul>
        <h2 className="text-[#212121] font-medium text-base">
          {" "}
          ⚠️ {t("please note:")}
        </h2>
        <ul className="list-disc pl-6">
          <li>{t("approval may take 24–48 hours after your request.")}</li>
          <li>{t("you'll receive an email once the integration is activated.")}</li>
        </ul>
      </div>
    </div>
  );
};

export default RequestModal;
